/**
 * Number formatter
 *
 * @param {*} number
 * @param {*} decimals
 * @param {*} dec_point
 * @param {*} thousands_sep
 */
function number_format(number, decimals, dec_point, thousands_sep) {

    var n = number,
        c = isNaN(decimals = Math.abs(decimals)) ? 2 : decimals;
    var d = dec_point == undefined ? "." : dec_point;
    var t = thousands_sep == undefined ? "," : thousands_sep,
        s = n < 0 ? "-" : "";
    var i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "",
        j = (j = i.length) > 3 ? j % 3 : 0;

    return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");

}

/*
*
* Remove bootstap modal padding
*
*/
$(document).ready(function(){
    $(window).on("load",function(){
        var oldSSB = $.fn.modal.Constructor.prototype.setScrollbar;
        $.fn.modal.Constructor.prototype.setScrollbar = function () 
        {
            oldSSB.apply(this);
            if(this.bodyIsOverflowing && this.scrollbarWidth) 
            {
                $('.new-menu.content-target,.floatingIcon').css('padding-right', this.scrollbarWidth);
            }       
        }
        var oldRSB = $.fn.modal.Constructor.prototype.resetScrollbar;
        $.fn.modal.Constructor.prototype.resetScrollbar = function () 
        {
            oldRSB.apply(this);
            $('.new-menu.content-target,.floatingIcon').css('padding-right', '');
        }
    });
});


/**
 * Math round function
 *
 * @param {*} value
 * @param {*} decimals
 */
function round(value, decimals) {

    return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);

}

/**
 * Add slashes
 *
 * @param {*} str
 */
function addslashes(str) {

    str = str.replace(/\\/g, '\\\\');
    str = str.replace(/\'/g, '\\\'');
    str = str.replace(/\"/g, '\\"');
    str = str.replace(/\0/g, '\\0');

    return str;

}

/**
 * Strip slashes
 *
 * @param {*} str
 */
function stripslashes(str) {

    str = str.replace(/\\'/g, '\'');
    str = str.replace(/\\"/g, '"');
    str = str.replace(/\\0/g, '\0');
    str = str.replace(/\\\\/g, '\\');

    return str;

}

/**
 * Encode in base 64
 *
 * @param {*} str
 */
function base64_encode(str) {

    if (window.btoa) { // Internet Explorer 10 and above

        return window.btoa(unescape(encodeURIComponent(str)));

    } else {

        // Create Base64 Object
        var Base64 = {
            _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
            encode: function(e) {
                var t = "";
                var n, r, i, s, o, u, a;
                var f = 0;
                e = Base64._utf8_encode(e);
                while (f < e.length) {
                    n = e.charCodeAt(f++);
                    r = e.charCodeAt(f++);
                    i = e.charCodeAt(f++);
                    s = n >> 2;
                    o = (n & 3) << 4 | r >> 4;
                    u = (r & 15) << 2 | i >> 6;
                    a = i & 63;
                    if (isNaN(r)) { u = a = 64 } else if (isNaN(i)) { a = 64 }
                    t = t + this._keyStr.charAt(s) + this._keyStr.charAt(o) + this._keyStr.charAt(u) + this._keyStr.charAt(a)
                }
                return t
            },
            decode: function(e) {
                var t = "";
                var n, r, i;
                var s, o, u, a;
                var f = 0;
                e = e.replace(/[^A-Za-z0-9\+\/\=]/g, "");
                while (f < e.length) {
                    s = this._keyStr.indexOf(e.charAt(f++));
                    o = this._keyStr.indexOf(e.charAt(f++));
                    u = this._keyStr.indexOf(e.charAt(f++));
                    a = this._keyStr.indexOf(e.charAt(f++));
                    n = s << 2 | o >> 4;
                    r = (o & 15) << 4 | u >> 2;
                    i = (u & 3) << 6 | a;
                    t = t + String.fromCharCode(n);
                    if (u != 64) { t = t + String.fromCharCode(r) }
                    if (a != 64) { t = t + String.fromCharCode(i) }
                }
                t = Base64._utf8_decode(t);
                return t
            },
            _utf8_encode: function(e) {
                e = e.replace(/\r\n/g, "\n");
                var t = "";
                for (var n = 0; n < e.length; n++) {
                    var r = e.charCodeAt(n);
                    if (r < 128) { t += String.fromCharCode(r) } else if (r > 127 && r < 2048) {
                        t += String.fromCharCode(r >> 6 | 192);
                        t += String.fromCharCode(r & 63 | 128)
                    } else {
                        t += String.fromCharCode(r >> 12 | 224);
                        t += String.fromCharCode(r >> 6 & 63 | 128);
                        t += String.fromCharCode(r & 63 | 128)
                    }
                }
                return t
            },
            _utf8_decode: function(e) {
                var t = "";
                var n = 0;
                var r = c1 = c2 = 0;
                while (n < e.length) {
                    r = e.charCodeAt(n);
                    if (r < 128) {
                        t += String.fromCharCode(r);
                        n++
                    } else if (r > 191 && r < 224) {
                        c2 = e.charCodeAt(n + 1);
                        t += String.fromCharCode((r & 31) << 6 | c2 & 63);
                        n += 2
                    } else {
                        c2 = e.charCodeAt(n + 1);
                        c3 = e.charCodeAt(n + 2);
                        t += String.fromCharCode((r & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
                        n += 3
                    }
                }
                return t
            }
        };

        // Encode the String
        return Base64.encode(unescape(encodeURIComponent(str)));

    }

};

/**
 * Decode from base 64
 *
 * @param {*} str
 */
function base64_decode(str) {

    if (window.atob) { // Internet Explorer 10 and above

        return decodeURIComponent(escape(window.atob(str.replace(/^"(.*)"$/, '$1'))));

    } else {

        // Create Base64 Object
        var Base64 = {
            _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
            encode: function(e) {
                var t = "";
                var n, r, i, s, o, u, a;
                var f = 0;
                e = Base64._utf8_encode(e);
                while (f < e.length) {
                    n = e.charCodeAt(f++);
                    r = e.charCodeAt(f++);
                    i = e.charCodeAt(f++);
                    s = n >> 2;
                    o = (n & 3) << 4 | r >> 4;
                    u = (r & 15) << 2 | i >> 6;
                    a = i & 63;
                    if (isNaN(r)) { u = a = 64 } else if (isNaN(i)) { a = 64 }
                    t = t + this._keyStr.charAt(s) + this._keyStr.charAt(o) + this._keyStr.charAt(u) + this._keyStr.charAt(a)
                }
                return t
            },
            decode: function(e) {
                var t = "";
                var n, r, i;
                var s, o, u, a;
                var f = 0;
                e = e.replace(/[^A-Za-z0-9\+\/\=]/g, "");
                while (f < e.length) {
                    s = this._keyStr.indexOf(e.charAt(f++));
                    o = this._keyStr.indexOf(e.charAt(f++));
                    u = this._keyStr.indexOf(e.charAt(f++));
                    a = this._keyStr.indexOf(e.charAt(f++));
                    n = s << 2 | o >> 4;
                    r = (o & 15) << 4 | u >> 2;
                    i = (u & 3) << 6 | a;
                    t = t + String.fromCharCode(n);
                    if (u != 64) { t = t + String.fromCharCode(r) }
                    if (a != 64) { t = t + String.fromCharCode(i) }
                }
                t = Base64._utf8_decode(t);
                return t
            },
            _utf8_encode: function(e) {
                e = e.replace(/\r\n/g, "\n");
                var t = "";
                for (var n = 0; n < e.length; n++) {
                    var r = e.charCodeAt(n);
                    if (r < 128) { t += String.fromCharCode(r) } else if (r > 127 && r < 2048) {
                        t += String.fromCharCode(r >> 6 | 192);
                        t += String.fromCharCode(r & 63 | 128)
                    } else {
                        t += String.fromCharCode(r >> 12 | 224);
                        t += String.fromCharCode(r >> 6 & 63 | 128);
                        t += String.fromCharCode(r & 63 | 128)
                    }
                }
                return t
            },
            _utf8_decode: function(e) {
                var t = "";
                var n = 0;
                var r = c1 = c2 = 0;
                while (n < e.length) {
                    r = e.charCodeAt(n);
                    if (r < 128) {
                        t += String.fromCharCode(r);
                        n++
                    } else if (r > 191 && r < 224) {
                        c2 = e.charCodeAt(n + 1);
                        t += String.fromCharCode((r & 31) << 6 | c2 & 63);
                        n += 2
                    } else {
                        c2 = e.charCodeAt(n + 1);
                        c3 = e.charCodeAt(n + 2);
                        t += String.fromCharCode((r & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
                        n += 3
                    }
                }
                return t
            }
        }

        // Encode the String
        return decodeURIComponent(escape(Base64.decode(str.replace(/^"(.*)"$/, '$1'))));

    }

};



function dateSelect() {
    $('.datepicker-button').mouseover(function() {

        console.log("mouseover");
        var input = document.querySelectorAll(".input-group span");
        if (window.navigator.userAgent.indexOf("MSIE ") != -1){
        	input = Array.prototype.slice.call(input);
        }
        if (input.length > 0) {
            input.forEach(function(e) {
                var title = e.title;
                console.log(title);
                if (title.indexOf('Изабери датум ...') > -1) {
                    console.log("true");
                    newtitle = title.replace('Изабери датум ...',
                        "Izaberi datum…");
                    console.log(newtitle);
                    e.title = newtitle;
                }
            })
        }
    })
}



/*
*
* Check CUI value
*
*/
$(document).ready(function(){
    $(window).on("load",function(){
        //Spostare in un altro punto del codice
        if ($("html").attr("data-bank") == "ISPROMANIA") {
            if(window.location.href.split("#")[1] != undefined){
                $("input[name='CUI']").val(window.location.href.split("#")[1])
            }
        }
    });
});




/**
 * Custom content load event callback
 *
 */
window.docuementLoadedCustum = function() {
	
    //defLabel
    var defLabel = null;
    	
    // log
    // console.log( JSON.parse( $( "#genericSettings" ).val() ) );

    // wait Bitmama slider script
    setTimeout(function() {


        // init calculator

        var loanISPSLOVENIA = Intesa.LoanCalculatorISPSLOVENIA.getInstance();
        loanISPSLOVENIA.init();

        // init calculator
        //var loanISPROMANIA = Intesa.LoanCalculatorISPROMANIA.getInstance();
        //loanISPROMANIA.init();

        // init calculator
        var loan = Intesa.LoanCalculator.getInstance();
        loan.init();

        // init calculator
        var mortgage = Intesa.MortgageCalculator.getInstance();
        mortgage.init();

        // init calculator
        var loanAlbania = Intesa.LoanCalculatorAlbania.getInstance();
        loanAlbania.init();

        // init calculator
        var loanAlex = Intesa.LoanCalculatorAlex.getInstance();
        loanAlex.init();

        // init calculator
        var loanPBZ = Intesa.LoanCalculatorPBZ.getInstance();
        loanPBZ.init();
        
        // init calculator
        var loanISPBIH = Intesa.LoanCalculatorISPBIH.getInstance();
        loanISPBIH.init();

        // init calculator
        var loanBIB = Intesa.LoanCalculatorBIB.getInstance();
        loanBIB.init();
        
        var loanBIBCombined = Intesa.LoanCalculatorBIBCombined.getInstance();
        loanBIBCombined.init();
        
        var loanRomania = Intesa.LoanCalculatorRomania.getInstance();
        loanRomania.init();

        var loanVUB = Intesa.LoanCalculatorVUB.getInstance();
        loanVUB.init();

        var loanAll = Intesa.LoanCalculatorAll.getInstance();
        loanAll.init();
        
        var bibTableComponent = Intesa.bibTableComponent.getInstance();
        bibTableComponent.init();
        
        //per ogni nuovo js dei calcolatori aggiungere il push 
        loanAll.allBanksCalculators.push(loan);
        loanAll.allBanksCalculators.push(mortgage);
        loanAll.allBanksCalculators.push(loanAlbania);
        loanAll.allBanksCalculators.push(loanAlex);
        loanAll.allBanksCalculators.push(loanPBZ);
        loanAll.allBanksCalculators.push(loanBIB);
        loanAll.allBanksCalculators.push(loanBIBCombined);
        loanAll.allBanksCalculators.push(loanRomania);

        var investmentVUB = Intesa.InvestmentCalculatorVUB.getInstance();
        investmentVUB.init();

        var createLink = Intesa.CreateLink.getInstance();
        createLink.init();
        
        // init currency converter
        var currencyConverter = Intesa.CurrencyConverter.getInstance();
        currencyConverter.init();
        
        var bid = Intesa.Bid.getInstance();
        bid.init();

        var selectCurrencies = Intesa.SelectCurrencies.getInstance();
        selectCurrencies.init();

        var merchantList = Intesa.MerchantList.getInstance();
        merchantList.init();

        var comparingTool = Intesa.ComparingTool.getInstance();
        comparingTool.init();

        
        
//        var calculatorNavigation = Intesa.CalculatorNavigation.getInstance();
//        calculatorNavigation.init();
        

        var formValidatorPbz = Intesa.FormValidatorsPbz.getInstance();
        formValidatorPbz.init();
        
        var AppleBusinessWidget = Intesa.appleBusinessWidget.getInstance();
        AppleBusinessWidget.init();
        

        var formsVub = Intesa.FormsVub.getInstance();
        formsVub.init();

        if($("html").attr("data-bank") == "CIB" && $(".js-landing__form").length>0){
            var formsLanding = Intesa.FormsLanding.getInstance();
            formsLanding.init();
        }

        var localStorageImplementations = Intesa.LocalStorageImplementations.getInstance();
        localStorageImplementations.init();
        
        var redirectToRightStore = Intesa.RedirectToRightStore.getInstance();
        redirectToRightStore.init();
        
        if( $('[data-layer-tab="unsubscribe"]').length > 0 || $('[data-layer-tab="subscribe"]').length > 0){
            var subscribeUnsubscirbe = Intesa.SubscribeUnsubscribe.getInstance();
            subscribeUnsubscirbe.init();
        }
    
        //init ckeditor field romania complaint
/*        if(window.CKEDITOR != undefined){
        	var wordCKEditorConf = {maxCharCount: 2000};
        	window.CKEDITOR.replace('htmlLegalInformation', {wordcount: wordCKEditorConf});
        	if(window.CKEDITOR.instances.htmlLegalInformation != undefined){
        		window.CKEDITOR.instances.htmlLegalInformation.on( 'change', function() {
            		var value = window.CKEDITOR.instances.htmlLegalInformation.getData();
            		$("#htmlLegalInformation").val(value);
            	});
        	}
        } not used
*/
        
      //inserito if per controllo su banca bib altrimenti questo js manda in errore i date picker sulle altre banche
        if($('html').attr('data-bank') == "BIB"){
        	dateSelect();
        }


    }, 1000);
    
	 setTimeout(function() {
			if($(".tbl__title").length > 0 ){
				for(i = 0; i < $(".tbl__title").length; i++){
				    if($($(".tbl__title")[i]).text() == "EUR_NET"){
				        $($(".tbl__title")[i]).text("EUR NET")
				    }
				}
			}
	},1000);

 //add * in SLOVENIA
	 setTimeout(function(){
		 var bank = $('html').attr('data-bank');
			if (bank.indexOf('ISPSLOVENIA') > -1) {
				var currencies = document.querySelectorAll(".tbl__title");
				  if (window.navigator.userAgent.indexOf("MSIE ") != -1){
			        	currencies = Array.prototype.slice.call(currencies);
			        }
				currencies.forEach(function(entry) {
					var curr = entry.innerText;
					if (curr.indexOf('NOK') > -1) {
						newcurr = curr.replace('NOK', "NOK *");
						entry.innerText = newcurr;
					} else if(curr.indexOf('PLN') > -1) {
						newcurr = curr.replace('PLN', "PLN *");
						entry.innerText = newcurr;
					} else if(curr.indexOf('SEK') > -1) {
						newcurr = curr.replace('SEK', "SEK *");
						entry.innerText = newcurr;
					}  else if (curr.indexOf('DKK') > -1) {
						newcurr = curr.replace('DKK', "DKK *");
						entry.innerText = newcurr;
					} 
				})
			}
		 },1000);
	 
	 //remove * in SLOVENIA EXCHANGE VISA E MASTERCARD
	 setTimeout(function(){
		 var bank = $('html').attr('data-bank');
			if (bank.indexOf('ISPSLOVENIA') > -1) {
				var currenciesVM = document.querySelectorAll(".hideTable .tbl__title");
				  if (window.navigator.userAgent.indexOf("MSIE ") != -1){
					  currenciesVM = Array.prototype.slice.call(currenciesVM);
			        }
				  currenciesVM.forEach(function(entry) {
					var currency = entry.innerText;
					if (currency.indexOf('NOK *') > -1) {
						newcurrency = currency.replace('NOK *', "NOK");
						entry.innerText = newcurrency;
					} else if(currency.indexOf('PLN *') > -1) {
						newcurrency = currency.replace('PLN *', "PLN");
						entry.innerText = newcurrency;
					} else if(currency.indexOf('SEK *') > -1) {
						newcurrency = currency.replace('SEK *', "SEK");
						entry.innerText = newcurrency;
					}  else if (currency.indexOf('DKK *') > -1) {
						newcurrency = currency.replace('DKK *', "DKK");
						entry.innerText = newcurrency;
					} 
				})
			}
		 },1000);


	//after past resize
	 setTimeout(function(){
		 var bank = $('html').attr('data-bank');
			if (bank.indexOf('ALEX') > -1) {
				textarea = document.querySelector("textarea");
				if(textarea != null){
					textarea.addEventListener('input', autoResize, false);
				
				}
			}
		 },1000);
	 
	 function autoResize() {
         this.style.height = 'auto';
         this.style.height = this.scrollHeight + 'px';
     }


    // init component
    var data_Layer = Intesa.DataLayer.getInstance();
    data_Layer.init();

    // init component
    var basketCookie = Intesa.BasketCookie.getInstance();
    basketCookie.init();

    // init basket core
    var basket_core = Intesa.BasketCore.getInstance();
    basket_core.init();

    // init datepicker_appointment
    var datePickerApp = Intesa.DatePickerAppointment.getInstance();
    datePickerApp.init();

    // init inputToArab
    // var inputToArab = Intesa.InputToArab.getInstance();
    // inputToArab.init();


    // TODO: check if correct
    // init component PBZ 
    var isPBZ = $('html').attr('data-bank') == 'PBZ';
    var isCIB = $('html').attr('data-bank') == 'CIB';
    var isSLO = $('html').attr('data-bank') == 'ISPSLOVENIA';
    var isBIB = $('html').attr('data-bank') == 'BIB';
    var isALB = $('html').attr('data-bank') == 'ISPALBANIA';

    // inizializzaione CIB & SLO
    if ((isCIB || isSLO) && !isPBZ) {
        var forms = Intesa.Forms.getInstance();
        forms.init();
    }
    
    if (isCIB) {
        //init survey loan
        var survey = Intesa.Survey.getInstance();
        survey.init();
    }
    
    // inizializzaione PBZ
    if (isPBZ && (!isCIB || !isSLO)) {
        var formsPBZ = Intesa.FormsPBZ.getInstance();
        formsPBZ.init();
    }
    
    // inizializzaione BIB
    if (isBIB) {
        var formsBIB = Intesa.FormsBIB.getInstance();
        formsBIB.init();
    }
    
    // inizializzaione ISPALBANIA
    if (isALB) {
        var formsISPALBANIA = Intesa.FormsISPALBANIA.getInstance();
        formsISPALBANIA.init();
    }
    
    // init ticketing complaint component
    var ticketing_complaint = Intesa.TicketingComplaint.getInstance();
    ticketing_complaint.init();

    //init video player handler
    var videoPlayerHandler = Intesa.videoPlayerHandler.getInstance();
    videoPlayerHandler.init();
    

    // show modal after submitting form
    setTimeout(function() {
        if ($("[data-show-modal]").length) {

            $("[data-show-modal]").each(function (index, el) {

                if ($(this).attr("data-show-modal") == "true") {

                    var modalName = $(this).attr("id");
                    $("[data-bs-target='#" + modalName + "']").get(0).click();
    				$("#" + modalName).addClass("in");

                }

            });

        }
    }, 1000);
    

    //fixed menu when open login
    $('.sectionLogin').on('click', function() {
        $('.topNavigation').toggleClass('fixedNavigation');
    });

    //no white space in dropdown AboutUs
    $('[data-internal-nav-btn]').on('click',function(){
    	$(this).toggleClass('noSpace');
    });
    
    //ALL BANKS FORMS BUTTON LOADER
    $('.j-leaveMessage__submit').on('click',function(e){
        console.log("DBG: generic leaveMessageSubmit event")
        var form = $(e.currentTarget).closest('.j-for__form');
        var formValid = form.parsley().isValid();
        if (!formValid){
        	console.log("Check your form");
        } else {
        	setTimeout(function(){
        	$('.j-leaveMessage__submit')[0].innerHTML = '<style>.loading{animation:rotate 1.5s linear infinite; margin-bottom: 5px;}@keyframes rotate{to{transform:rotate(360deg);}}</style><span><img class="loading" src="/.resources/intesaSanPaolo-templating-module/templates/webresources/CIB/images/load-icon.png" width="22" height="22"></img></span>';
        	$('.j-leaveMessage__submit')[0].disabled = true;
        	}, 40);
        }
    });

      //CALL ME BACK BUTTON LOADER
    $('.cmb__modal__btnAgree').on('click',function(){
        console.log("DBG: generic cmb modal btnAgree event")
    	if (defLabel == null){
    	defLabel = $('.cmb__modal__btnSend')[0].innerHTML;
    	}
    	$('.cmb__modal__btnSend')[0].innerHTML = defLabel;
    	$('.cmb__modal__btnSend')[0].disabled = false;
    });
    
    $('.cmb__modal__btnSend').on('click',function(e){

        console.log("DBG: generic cmb modal btnSend event")
        var form = $(e.currentTarget).closest('.j-for__form');
        var formValid = form.parsley().isValid();
        if (!formValid){
        	console.log("Check your form");
        }
        else {
        	setTimeout(function(){
        	$('.cmb__modal__btnSend')[0].innerHTML = '<style>.loading{animation:rotate 1.5s linear infinite; margin-bottom: 5px;}@keyframes rotate{to{transform:rotate(360deg);}}</style><span><img class="loading" src="/.resources/intesaSanPaolo-templating-module/templates/webresources/CIB/images/load-icon.png" width="22" height="22"></img></span>';
        	$('.cmb__modal__btnSend')[0].disabled = true;
        	}, 40);
        }

    });
    
    //CIB LOADER
    if($('.cib .j-leaveMessage__submit').length > 0){
	    $('.cib .j-leaveMessage__submit').on('click',function(e){
	        var form = $(e.currentTarget).closest('.j-for__form');
	        var formValid = form.parsley().isValid();
	        if (!formValid){
	        	console.log("Check your form");
	        } else {
	        	setTimeout(function(){
	        	$('.cib .j-leaveMessage__submit')[0].innerHTML = '<style>.loading{animation:rotate 1.5s linear infinite; margin-bottom: 5px;}@keyframes rotate{to{transform:rotate(360deg);}}</style><span><img class="loading" src="/.resources/intesaSanPaolo-templating-module/templates/webresources/CIB/images/load-icon.png" width="22" height="22"></img></span>';
	        	$('.cib .j-leaveMessage__submit')[0].disabled = true;
	        	}, 40);
	        }
	    });
    }
    
    if($('.cib .cmb__modal__btnAgree').length > 0){
	    $('.cib .cmb__modal__btnAgree').on('click',function(){
	    	if (defLabel == null){
	    	defLabel = $('.cib .cmb__modal__btnSend')[0].innerHTML;
	    	}
	    	$('.cib .cmb__modal__btnSend')[0].innerHTML = defLabel;
	    	$('.cib .cmb__modal__btnSend')[0].disabled = false;
	    });
    }
    
    if($('.cib .cmb__modal__btnSend').length > 0){
	    $('.cib .cmb__modal__btnSend').on('click',function(e){
	        var form = $(e.currentTarget).closest('.j-for__form');
	        var formValid = form.parsley().isValid();
	        if (!formValid){
	        	console.log("Check your form");
	        }
	        else {
	        	setTimeout(function(){
	        	$('.cib .cmb__modal__btnSend')[0].innerHTML = '<style>.loading{animation:rotate 1.5s linear infinite; margin-bottom: 5px;}@keyframes rotate{to{transform:rotate(360deg);}}</style><span><img class="loading" src="/.resources/intesaSanPaolo-templating-module/templates/webresources/CIB/images/load-icon.png" width="22" height="22"></img></span>';
	        	$('.cib .cmb__modal__btnSend')[0].disabled = true;
	        	}, 40);
	        }
	
	    });
	    
	    
    }
    
   //ROMANIA LOADER
    
    if($('.ispromania .j-leaveMessage__submit').length > 0){
	    $('.ispromania .j-leaveMessage__submit').on('click',function(e){
	        var form = $(e.currentTarget).closest('.j-for__form');
	        var formValid = form.parsley().isValid();
	        if (!formValid){
	        	console.log("Check your form");
	        } else {
	        	setTimeout(function(){
	        	$('.ispromania .j-leaveMessage__submit')[0].innerHTML = '<style>.loading{animation:rotate 1.5s linear infinite; margin-bottom: 5px;}@keyframes rotate{to{transform:rotate(360deg);}}</style><span><img class="loading" src="/.resources/intesaSanPaolo-templating-module/templates/webresources/CIB/images/load-icon.png" width="22" height="22"></img></span>';
	        	$('.ispromania .j-leaveMessage__submit')[0].disabled = true;
	        	}, 40);
	        }
	    });
    }
    
    if($('.ispromania .cmb__modal__btnAgree').length > 0){
	    $('.ispromania .cmb__modal__btnAgree').on('click',function(){
	    	if (defLabel == null){
	    	defLabel = $('.ispromania .cmb__modal__btnSend')[0].innerHTML;
	    	}
	    	$('.ispromania .cmb__modal__btnSend')[0].innerHTML = defLabel;
	    	$('.ispromania .cmb__modal__btnSend')[0].disabled = false;
	    });
    }
    
    if($('.ispromania .cmb__modal__btnSend').length > 0){
	    $('.ispromania .cmb__modal__btnSend').on('click',function(e){
	        var form = $(e.currentTarget).closest('.j-for__form');
	        var formValid = form.parsley().isValid();
	        if (!formValid){
	        	console.log("Check your form");
	        }
	        else {
	        	setTimeout(function(){
	        	$('.ispromania .cmb__modal__btnSend')[0].innerHTML = '<style>.loading{animation:rotate 1.5s linear infinite; margin-bottom: 5px;}@keyframes rotate{to{transform:rotate(360deg);}}</style><span><img class="loading" src="/.resources/intesaSanPaolo-templating-module/templates/webresources/CIB/images/load-icon.png" width="22" height="22"></img></span>';
	        	$('.ispromania .cmb__modal__btnSend')[0].disabled = true;
	        	}, 40);
	        }
	
	    });
    }
    
    //PBZ LOADER
    if($('.pbz .j-leaveMessage__submit').length > 0){
        $('.pbz .j-leaveMessage__submit').on('click',function(e){
            var form = $(e.currentTarget).closest('.j-for__form');
            var formValid = form.parsley().isValid();
            if (!formValid){
                console.log("Check your form");
            } else {
                setTimeout(function(){
                $('.pbz .j-leaveMessage__submit')[0].innerHTML = '<style>.loading{animation:rotate 1.5s linear infinite; margin-bottom: 5px;}@keyframes rotate{to{transform:rotate(360deg);}}</style><span><img class="loading" src="/.resources/intesaSanPaolo-templating-module/templates/webresources/CIB/images/load-icon.png" width="22" height="22"></img></span>';
                $('.pbz .j-leaveMessage__submit')[0].disabled = true;
                }, 40);
            }
        });
    }
  
    // prize winning games consents
	$("[name='leaveMessage__form'] .leaveMessage__submit").on("click", function () { 
		if( $("#checkbox10").length != 0) { 
			var count = 0;
			var idConsents = "#checkbox1";
			var currentIdConsents = idConsents + count;
			var consentsObject = {};
			while($(currentIdConsents).length != 0){
				var nameConsent = $(currentIdConsents).attr('name');
				var valueConsent = $(currentIdConsents).is(":checked");
				consentsObject[nameConsent] = valueConsent;
				count = count + 1;
				currentIdConsents = idConsents + count;
			}
			if( $('[name="consentsPrizeWinningGame"]').length != 0){
				$('[name="consentsPrizeWinningGame"]').val(JSON.stringify(consentsObject));
			}
			else{
				$('form[name="leaveMessage__form"]').append("<input type='hidden' name='consentsPrizeWinningGame' value='" + JSON.stringify(consentsObject) + "'/>");
			}
		} 
	});

    //Get member form
    $("#termsandcoditions_link_modal").click(function () {
        $("#showTermsModal").modal("show");
        setTimeout(function () {
            if (($("#modalBody").prop('scrollHeight') - $("#modalBody").prop('scrollTop')) < 450) {
                document.getElementById("acceptTerms").disabled = false;
                document.getElementById("acceptTerms").style.opacity = "1";
                console.log($("#modalBody").prop('scrollHeight') - $("#modalBody").prop('scrollTop'));
            }
        }, 500)
    });

    if(document.getElementById('acceptTerms') != null){
        document.getElementById("acceptTerms").disabled = true;
        document.getElementById("acceptTerms").style.opacity = "0.5";
    }

	$("#acceptTerms").click(function () {
		$('#termsAndConditionsHtml').prop('checked', true);
		$('input[name="termsAndConditions"]').val(true);
	});
	
	$("#gdprPrivacyHtml").click(function () {
		$('#gdprPrivacy').val(true);
	});

    $('#showTermsModal').on('hidden.bs.modal', function () {
        $([document.documentElement, document.body]).animate({
            scrollTop: $("#item_firstnameGuest").offset().top
        }, 1000);
    });

    $( "#modalBody" ).on( "scroll", function() {
        if(($("#modalBody").prop('scrollHeight')-$("#modalBody").prop('scrollTop'))<450){
            document.getElementById("acceptTerms").removeAttribute("disabled");
            document.getElementById("acceptTerms").disabled = false;
            document.getElementById("acceptTerms").style.opacity = "1";
        }
     });

};

/**
 * Generic scroll to anchor
 *
 */
$('body').on('click', 'a[data-scrollto]', function(event) {

    event.preventDefault();

    var targetId = $(this).attr('data-scrollto');

    var distanceFromTop = 80;

    if ($(window).width() < 690) {
        distanceFromTop = 10;
    }

    $('html,body').animate({
        scrollTop: $(targetId).offset().top - distanceFromTop
    }, 500);

});

// Content Adaptive Cookie
$(document).ready(function() {

    var cookieDataContainer = $('#content-adaptive-data');

    var requestId = $("#requestId");

    if (requestId.length) {

        requestId.val(getRequestFormId());

    }

    if (cookieDataContainer.length) {

        var cookieValue = cookieDataContainer.attr('data-value');
        var cookieName = cookieDataContainer.attr('data-name');

        var cookieExpirationInDays = cookieDataContainer.attr('data-expire-after');
        var cookieWaitTimeInSeconds = cookieDataContainer.attr('data-show-after');
        cookieWaitTimeInSeconds = parseInt(cookieWaitTimeInSeconds);
        cookieWaitTimeInSeconds = cookieWaitTimeInSeconds * 1000; // convert to milliseconds

        // Set after tot seconds
        setTimeout(function() {

            setCookie(cookieValue, cookieExpirationInDays, cookieName);

        }, cookieWaitTimeInSeconds);

    }

    var requestId = $('#requestId');

    if (requestId.length) {

        requestId.attr("value", getRequestFormId());

    }

});

$(document).ready(function () {
    if ($(window).width() > 768) {
        $('.mobile-video-ourworld').remove();
    } else {
        $('.desktop-video-ourworld').remove();
    }
    if ($(".comparingTool").length != 0) {

        switch (mobileStore) {
            case googleStore:
                linkToStore = $("[name=linkToAndroidStore]").attr("value");
                break;

            case appleStore:
                linkToStore = $("[name=linkToIOSStore]").attr("value");
                break;

            case huaweiStore:
                linkToStore = $("[name=linkToHuaweiStore]").attr("value");
                break;

            default:
                break;
        }

        var qrLink = window.location.href.split('?')[0] + "?android=" + $("[name=linkToAndroidStore]").attr("value") + "&ios=" + $("[name=linkToIOSStore]").attr("value") + "&huawei=" + $("[name=linkToHuaweiStore]").attr("value");

        var qrLink = new QRious({
            element: document.getElementById("qr-modal-bottom"),
            value: qrLink
        });
        qrLink.set({
            background: 'white',
            backgroundAlpha: 1,
            foreground: 'black',
            foregroundAlpha: 1,
            level: 'H',
            padding: null,
            size: 225
        });

        var mobileStore = ComparingTool.getMobileStore();

        var linkToStore;

        $(".header-card a").each(function () {
            $(this).attr("href", linkToStore)
        });

        console.log("Intesa.RedirectToRightStore - END ")

        if (screen.width < 768) {
            //Set timeout to get the element size
            setTimeout(function () {
                function offset(el) {
                    var rect = el.getBoundingClientRect(),
                        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
                        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
                }
                var cardGroupOffset = offset(document.querySelector('.cardCompare-group'));
                var heightCardSelector = $('.cardCompare-group').height();
                var scrollLimit = heightCardSelector + cardGroupOffset.top + $(".mobile-compare > .for_table > .col-24").height();
                $(window).scroll(function (e) {
                    var $el = $('.cardCompare-group');
                    var isPositionFixed = ($el.css('position') == 'fixed');
                    if ($(this).scrollTop() < cardGroupOffset.top || $(this).scrollTop() > scrollLimit) {
                        $el.css({ 'position': 'static' });
                        $(".mobile-compare > .for_table").css({ "margin-top": "0px" });
                    } else {
                        $el.css({ 'position': 'fixed' });
                        $(".mobile-compare > .for_table").css({ "margin-top": "120px" });
                    }
                });
            }, 800);
        }
    }
});

$( document ).ready(function() {

//Get value CallMeBack
 $('input[name="callMeBackCheckbox"]').on("change", function(){
    $('input[name="isCallMe"]').val($('input[name="callMeBackCheckbox"]').prop('checked'));
});

});

// Set cookie
function setCookie(cvalue, exdays, cname) {

    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";

}


function pad(pad, str, padLeft) {

    if (typeof str === 'undefined')

        return pad;

    if (padLeft) {

        return (pad + str).slice(-pad.length);

    } else {

        return (str + pad).substring(0, pad.length);

    }

}

function getRequestFormId() {

    var date = new Date();

    var components = [

        pad('00000', date.getYear() + date.getMonth() + date.getDate() + date.getHours() + date.getMinutes(), true),

        "-",

        pad('00000', date.getSeconds(), true),

        "-",

        pad('00000', date.getMilliseconds(), true),

    ];

    return components.join("");


}

//ReCaptcha V3
$(document).ready(function () {

    if ($("input[name='recaptchaKey']").length >= 1) {

        var site_key = $("body").find(".g-recaptcha").attr("sitekey");

        var scriptGoogle = document.createElement('script');
        scriptGoogle.src = 'https://www.google.com/recaptcha/api.js?render=' + site_key;
        scriptGoogle.id = "googleCaptchaId";
        scriptGoogle.setAttribute('async', true);
        document.documentElement.querySelector('body').appendChild(scriptGoogle);
        var sectionCaptcha = $("form .leaveMessage__submit");
        console.log("Form founded:" + (sectionCaptcha.length > 0));
        setTimeout(function () {
            if (window.grecaptcha != null || window.grecaptcha != undefined) {
                grecaptcha.ready(function () {
                    console.log("ready captcha");
                    if (sectionCaptcha.length > 0) {
                        var recaptchaResponse = document.createElement('textarea');
                        recaptchaResponse.name = "g-recaptcha-response";
                        recaptchaResponse.setAttribute("class", "g-recaptcha-response");
                        recaptchaResponse.setAttribute('style', 'display:none');
                        var privacyGoogleCaptcha = document.createElement('div');
                        privacyGoogleCaptcha.classList.add('privacyRecaptcha');
                        privacyGoogleCaptcha.innerHTML = $(".g-recaptcha-privacy").attr("value");
                        if ($("form .leaveMessage__submit").parent().children(".g-recaptcha-response").length <= 0) {
                            $("form .leaveMessage__submit").parent().append(recaptchaResponse);
                            $("form .leaveMessage__submit").parent().append(privacyGoogleCaptcha);
                        } else if ($(".js-landing__form input[name='requestId']").length <= 0) {
                            $(".js-landing__form input[name='requestId']").append(recaptchaResponse);
                            $(".js-landing__form input[name='requestId']").append(privacyGoogleCaptcha);
                        } else if ($(".r-thankyou-page .leaveMessage__submitWrapper").length <= 0) {
                            $(".r-thankyou-page .leaveMessage__submitWrapper").append(recaptchaResponse);
                            $(".r-thankyou-page .leaveMessage__submitWrapper").append(privacyGoogleCaptcha);
                        }
                        if($("div[data-component='Callmeback']").length>0){
                            window.grecaptcha.execute($("body").find(".g-recaptcha").attr("sitekey"), {
                                action: "contact"
                            }).then(function (token) {
                                $("div[data-component='Callmeback'] form .g-recaptcha-response").val(token)
                            });
                        }
                    } else {
                        grecaptcha.execute(site_key, {
                            action: "homepage"
                        })
                    }
                });

            }
        }, 800);
    }
});

$(document).ready(function() {

    $('.inputRadio__face[data-question-placeholder]').click(function(e) {

        console.log('Init Emoticon');

        // get question from attribute
        var question = $(this).attr('data-question-placeholder');

        console.log('Question = ' + question);

        document.getElementById('_idqst').innerText = question;

    });

    var myWebList = document.getElementById("webinarList");

    if (myWebList) {

        var link = $("#webinarList").attr('data-link');
        var response = $("#webinarList").attr('data-response');
        //var expiredErrorMessage = $("#webinarList").attr('data-expired-message');

        var responseJSON = JSON.parse(response);



        var webinarsList = responseJSON.webinars;
        //console.log(webinarsList);

        for (var i in webinarsList) {
            if (webinarsList[i].agenda != "") {
                var agenda = webinarsList[i].agenda;
            }

            if (webinarsList[i].agenda == "" || webinarsList[i].agenda == undefined) {
                var agenda = "";
            }

            if (webinarsList[i].join_url != "") {

                if (link != "" && link != null) {
                    var join_url = link + "/" + webinarsList[i].id;
                } else {
                    var join_url = webinarsList[i].join_url;
                }

                //					if( webinarsList[i].sharedURL != "" && webinarsList[i].sharedURL != null ){
                //						var join_url = webinarsList[i].sharedURL;
                //					}
            }

            if (webinarsList[i].start_time != "" && webinarsList[i].start_time != null) {
                var start_time = webinarsList[i].start_time;
                var myDate = new Date(start_time);
                var outputDate = myDate.getDate() + "\\" + (myDate.getMonth() + 1) + "\\" + myDate.getFullYear() + "   " + myDate.getHours() + ":" + (myDate.getMinutes() < 10 ? '0' : '') + myDate.getMinutes(); //":"+(myDate.getSeconds()<10?'0':'') + myDate.getSeconds();	  		  		  	
            } else {
                //					if( webinarsList[i].type != 6){
                //						var outputDate = expiredErrorMessage;
                //					}else{
                var outputDate = "";
                //					}
            }


            if (webinarsList[i].topic != "") {
                var topic = webinarsList[i].topic;
            }


            $("#webinarList").append('<div class="content-column" id="content' + i + '"><p><a style="font-weight:bold;" id="join' + i + '"><span style="font-weight:bold;" id="description' + i + '"></span></a></p><p><span style="font-weight:bold;" id="date' + i + '"></span></p><p><span id="title' + i + '"></span></p></div>');


            document.getElementById("join" + i).setAttribute("href", join_url);
            document.getElementById("title" + i).innerHTML = agenda;
            document.getElementById("date" + i).innerHTML = outputDate;
            document.getElementById("description" + i).innerHTML = topic;


        }

    }


    //console.log("GET A WEBINAR");
    var myWebSing = document.getElementById("webinarSingle");
    if (myWebSing) {
        var response = $("#webinarSingle").attr('data-response');
        var responseJson = JSON.parse(response);

        //console.log(response);
        var url = responseJson.registration_url;
        if (url == null) {
            var url = responseJson.start_url;
        }
        document.getElementById("webinar").src = url;

    }
    
    //FadeOut overlay mobile
	$(".table__component").on("touchstart", function(){
		var isMobile_table = $(window).width() < 769;
		if($("#overlayShowed").val() == "false" && isMobile_table){
			$(".table__mobile__overlay").css("display", "block");
			$(".table__mobile__overlay").fadeOut(6000);
			
			$("#overlayShowed").val("true");
		}
	});
	
});

//cut .html
$(document).ready(function(){ 
	var ahref = document.querySelectorAll('a');
		ahref.forEach(function(entry) {
			if(entry.href.indexOf(".html/") > -1){
				entry.href = entry.href.split(".html/").join("/");
			}
		});
	});


//form select as input
$(document).ready(function(){ 
	var bank = $('html').attr('data-bank');
	console.log(bank);
	if (bank.indexOf('ALEX') > -1) {
		setDynamicTop('item_dynamicDropdown');
		setDynamicTop('item_dynamicDependentDropdown');
		setDynamicTop('item_dynamicDependentDropdown_DD');
	}
	});



function setDynamicTop(dataId){
		$('[data-id='+dataId+']').change(function(){
			if($('[data-id='+dataId+']:option selected').val() == undefined){
				$('label[for='+dataId+']').css('top','3px');
			}else{
				$('label[for='+dataId+']').css('top','0px');
			}
		});
	}


//select for one element XDPP-1399
setTimeout(function(){
	if ( $(window).width() < 990) {     
		console.log("mobile view");
		var elem = $('.com4__mobileNav');
		var taga = $('li.com4__listItem a');
		var spana= $('.com4__mobileNav span');
		
		if(taga.length == 1){
			console.log("one");
			elem.removeClass('.com4__mobileNav').addClass('newClass');
				spana.replaceWith(function() {
						return  taga;

					});
		
		}
		$( ".newClass" ).click(function() {
			console.log("remove box bianco");
			  $( "ul" ).remove();
			});
	}
    },150);



//disable submit button XDCR-2139
setTimeout(function(){
	
	if($('.dz-error-message').length > 0){
		console.log("errore presente");
	$('.leaveMessage__submit').attr('type', '');

		}
},2000);

//hide filter in about us map world 
setTimeout(function(){
	var dataworld= $('section.branchLocator__wrapper').attr('data-world')
	if(dataworld =='intesa-world'){
		console.log("oscura filtri");
		$('button.wrapperLbsFilter__buttonFiltering').hide();
	}

},180);


$( document ).ready(function() {
    if($(window).width() > 768){
		$('.mobile-video-ourworld').remove();
	}else{
		$('.desktop-video-ourworld').remove();
	}
});

//prtnership
setTimeout(function(){
	if ( $(window).width() < 990) {
		console.log("mobile view");
		var optionis = $("#mobileTags option");
			console.log(optionis.length);
				options = Array.prototype.slice.call(optionis);
			 options.forEach(function(entry) {
		        var option = entry.innerText;
				var option_capitalize= option.charAt(0).toUpperCase() + option.slice(1).toLowerCase();
				console.log(option_capitalize);
				var newoption= option.replace(option, option_capitalize);
				entry.innerText = newoption;
			 });
	  }
},10);

setTimeout(function() {
    $('.titleTooltip').on('mouseenter', function() {
        var $tooltip = $(this);

        var distanceFromRight = $(window).width() - $tooltip.offset().left;
        var distanceFromLeft = $tooltip.offset().left;

        if(distanceFromRight < 100) {
            $tooltip.addClass('titleTooltip--to-left');
        }
        else if(distanceFromLeft < 100) {
            $tooltip.addClass('titleTooltip--to-right');
        }

    })
    
    $('.titleTooltip').on('mouseleave', function() {
        var $tooltip = $(this);
        
        $tooltip.removeClass('titleTooltip--to-right')
        $tooltip.removeClass('titleTooltip--to-left');
    })
}, 500)
/*
 * 
 * Global start demo floating icon functions
 * 
 * 
 */

window.startDemo = function () {
  setTimeout(function (){
        $(this.wrapper).addClass('demoFloating');
        showFloating();
  },1000)
}

window.stopDemo = function () {
	  setTimeout(function (){
	        hideFloating();
	  },1000)
	}

function showFloating () {
	var floatingIcon = $("[data-component='FloatingIcon']");
	floatingIcon.find('.j-trigger').addClass('triggered');
	floatingIcon.addClass('activateFloating');
	$('.floatingIcon--bg').addClass('activateFloating-bg');
	
}

function hideFloating () {
	var floatingIcon = $("[data-component='FloatingIcon']");
	floatingIcon.find('.j-trigger').removeClass('triggered');
    floatingIcon.removeClass('activateFloating demoFloating');
	$('.floatingIcon--bg').removeClass('activateFloating-bg');
    $('.floatingIcon__button').removeClass('menuActivated');
    $('html').removeClass('openSocialShareModal');
}
